import { render, staticRenderFns } from "./Timeslots.vue?vue&type=template&id=62756462&"
import script from "./Timeslots.vue?vue&type=script&lang=js&"
export * from "./Timeslots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports